//React imports
import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";

//Imports the components
import CarouselComponent from "../components/CarouselComponent.js";
import CalculatorComponent from "../components/calculator/CaculatorComponent.js";
import SolutionComponent from "../components/SolutionComponent.js";
import FooterComponent from "../components/home/FooterComponent.js";
import HeaderComponent from "../components/HeaderComponent.js";
import PricingComponent from "../components/pricing/PricingComponent.js";
import GuaranteeComponent from "../components/GuaranteeComponent.js";
import SecondaryPricingComponent from "../components/SecondaryPricingComponent.js";
import UnknownComponent from "../components/UnknownComponent.js";

//Imports assets such as images
import pabloo_transparent_logo_cropped from "../assets/pabloo_transparent_logo_cropped.png";
import NavBarComponent from "../components/navBar/NavBarComponent.js";
import { handleSubmission } from "../models/notifications.js";

function NotFoundPage() {
  return (
    <div>
      <div className="updated-page-wrapper">
        <NavBarComponent />

        <UnknownComponent />

        <FooterComponent />
      </div>
    </div>
  );
}

export default NotFoundPage;
